// app/javascript/packs/candidate_interest_indicator.js
document.addEventListener("turbolinks:load", () => {
    const validations = [
      {
        el:      document.getElementById("candidate_interest_indicator_first_name"),
        errEl:   document.getElementById("cii-first-name-error"),
        message: "First name is required."
      },
      {
        el:      document.getElementById("candidate_interest_indicator_last_name"),
        errEl:   document.getElementById("cii-last-name-error"),
        message: "Last name is required."
      },
      {
        el:      document.getElementById("candidate_interest_indicator_unit_address"),
        errEl:   document.getElementById("cii-unit-address-error"),
        message: "Unit address is required."
      }
    ];

    const email     = document.getElementById("candidate_interest_indicator_email");
    const emailErr  = document.getElementById("cii-email-error");
    const fileInput = document.getElementById("candidate_interest_indicator_candidate_biography");
    const fileErr   = document.getElementById("cii-bio-error");
    const phone     = document.getElementById("candidate_interest_indicator_phone_number");

    // Email regex
    function validEmail(val) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val);
    }

    // Format US numbers with optional leading “1” country code
    function formatPhoneNumber(val) {
      const digits = val.replace(/\D/g, "");

      // 11-digit starting with “1” → “1 (XXX) XXX-XXXX”
      if (digits.length === 11 && digits[0] === "1") {
        return `1 (${digits.slice(1,4)}) ${digits.slice(4,7)}-${digits.slice(7)}`;
      }
      // Plain 10-digit → “(XXX) XXX-XXXX”
      if (digits.length === 10) {
        return `(${digits.slice(0,3)}) ${digits.slice(3,6)}-${digits.slice(6)}`;
      }
      // otherwise leave as-is
      return val;
    }

    function showError(el, errEl, msg) {
      el.classList.add("border-red-500", "border-2", "animate-pulse");
      errEl.textContent = msg;
      errEl.classList.remove("hidden");
      setTimeout(() => el.classList.remove("animate-pulse"), 500);
    }

    function clearError(el, errEl) {
      el.classList.remove("border-red-500", "border-2");
      if (errEl) {
        errEl.textContent = "";
        errEl.classList.add("hidden");
      }
    }

    // Presence validators on blur/input
    validations.forEach(({ el, errEl, message }) => {
      if (!el || !errEl) return;

      el.addEventListener("blur", () => {
        if (el.value.trim() === "") showError(el, errEl, message);
      });
      el.addEventListener("input", () => {
        if (el.value.trim() !== "") clearError(el, errEl);
      });
    });

    // Email validators
    if (email && emailErr) {
      email.addEventListener("blur", () => {
        const v = email.value.trim();
        if (!validEmail(v)) showError(email, emailErr, "Please enter a valid email address.");
      });
      email.addEventListener("input", () => {
        if (validEmail(email.value.trim())) clearError(email, emailErr);
      });
    }

    // File validator (optional, PDF only).
    // The `accept="application/pdf"` attribute is only a hint — users can still
    // pick "All Files" and choose a Word doc, image, etc. This validates the
    // selected file by both MIME type and extension, and (below) blocks submit.
    const PDF_ERROR_MESSAGE =
      "Only PDF documents are permitted. Please upload a file that ends in .pdf.";

    function selectedFileIsPdf() {
      if (!fileInput || fileInput.files.length === 0) return true; // optional field
      const file = fileInput.files[0];
      const name = (file.name || "").toLowerCase();
      const type = (file.type || "").toLowerCase();
      // Require a .pdf extension AND, when the browser reports a type, that it be a PDF.
      const extensionOk = name.endsWith(".pdf");
      const typeOk      = type === "" || type === "application/pdf";
      return extensionOk && typeOk;
    }

    function validateFile() {
      if (!fileInput || !fileErr) return true;
      if (selectedFileIsPdf()) {
        clearError(fileInput, fileErr);
        return true;
      }
      showError(fileInput, fileErr, PDF_ERROR_MESSAGE);
      return false;
    }

    if (fileInput && fileErr) {
      fileInput.addEventListener("change", validateFile);
    }

    // Block submission when a non-PDF is attached so it never reaches the server.
    const form = document.getElementById("cii-form");
    if (form) {
      form.addEventListener("submit", (event) => {
        if (!validateFile()) {
          event.preventDefault();
          const announcer = document.getElementById("form-status-announcer");
          if (announcer) announcer.textContent = PDF_ERROR_MESSAGE;
          fileInput.focus();
        }
      });
    }

    // Phone formatting on input (optional field)
    if (phone) {
        // live as soon as they type enough digits
        phone.addEventListener("input", () => {
          const digits = phone.value.replace(/\D/g, "");
          if (digits.length === 10 || (digits.length === 11 && digits[0] === "1")) {
            phone.value = formatPhoneNumber(phone.value);
          }
        });

        // final pass on blur
        phone.addEventListener("blur", () => {
          const formatted = formatPhoneNumber(phone.value.trim());
          if (formatted !== phone.value) phone.value = formatted;
        });
      }
  });
